import { createFileRoute, redirect } from "@tanstack/react-router";

// /workspace is a way in; the first section is where a manager lands.
export const Route = createFileRoute("/dashboard/workspace/")({
  beforeLoad: () => {
    throw redirect({ to: "/dashboard/workspace/inspections" });
  },
});
